module.exports = __webpack_public_path__ + "static/media/fresh-veggie.d4e19f4c.jpg";